import {
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Underline,
  Heading,
  List,
  Link,
  Image,
  ImageToolbar,
  ImageCaption,
  ImageStyle,
  ImageResize,
  Table,
  TableToolbar,
  ImageUpload,
  Alignment,
  Font,
} from "ckeditor5";

import "ckeditor5/ckeditor5.css";

export const editorConfig = {
  licenseKey: "GPL",
  plugins: [
    Essentials,
    Paragraph,
    Bold,
    Italic,
    Underline,
    Heading,
    List,
    Link,
    Image,
    ImageToolbar,
    ImageCaption,
    ImageStyle,
    ImageResize,
    Table,
    TableToolbar,
    ImageUpload,
    Alignment,
    Font,
  ],
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "fontSize",
    "fontColor",
    "fontBackgroundColor",
    "|",
    "bold",
    "italic",
    "underline",
    "|",
    "alignment",
    "|",
    "bulletedList",
    "numberedList",
    "|",
    "link",
    "insertTable",
    "insertImage",
  ],
  image: {
    toolbar: [
      "imageTextAlternative",
      "toggleImageCaption",
      "imageStyle:inline",
      "imageStyle:block",
      "imageStyle:side",
    ],
  },
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  },
};
